import React, {useEffect, useState} from 'react';
import CircularLoader from "../Common/CircularLoader";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import ChefForPartyOrderList from './ChefForPartyOrderList';
import ChefForPartyService from '../../services/ChefForPartyService';

interface InputProps {
    partyId: number
}

const chefForPartyService = new ChefForPartyService();

const ChefForPartOrderTab = (props: InputProps) => {

    let [subData, setSubData] = useState<any>(null);
    let [party, setParty] = useState<any>(null);
    let [isLoading, setIsLoading] = useState<boolean>();

    const refreshData = (partyId: number) => {
        setIsLoading(true)
        chefForPartyService.fetchOneChefForParty(partyId)
            .then((data: any) => {
                setSubData(data?.data?.orders);
                setParty(data?.data)
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        refreshData(props.partyId);
    }, [props.partyId])

    return (
        <div>
            {
                isLoading ?
                    <CircularLoader/>
                    :
                    <div>
                        {subData &&
                            Array.isArray(subData) &&
                            (
                                subData.length>0 ?
                                    <ChefForPartyOrderList data={subData} party={party} refresh={() => {
                                        refreshData(Number(props.partyId))
                                    }}/>
                                    :
                                    <EmptyListPlaceholder
                                        message='No Order Found'
                                    />
                            )
                        }
                    </div>
            }
        </div>
    );
};

export default ChefForPartOrderTab;
